import { Component, OnInit } from '@angular/core';
import { Sitio } from '@app/_models';
import { Router, NavigationEnd } from "@angular/router"

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '@app/_services';
import { RecorridosEnteService } from '@app/_services/recorridos-ente.service';
import { Recorrido } from "@app/_models/recorrido";

@Component({
  selector: 'app-recorridos-ente',
  templateUrl: './recorridos-ente.component.html',
})
export class RecorridosEnteComponent implements OnInit {

  public seleccionados: number[] = [];
  private translate: TranslateService;
  public listaRecorridos:Recorrido[]=[];
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;
  closeResult = '';
  navigationSubscription;
  lang;

  constructor(private recorridosService: RecorridosEnteService,
    translate: TranslateService,
    private menuService: MenuService, public router: Router,
    private translateService: TranslateService,
    private modalService: NgbModal) {

    this.translate = translate;
    this.menuService.titulo = this.translate.instant('recorridos.recorridos').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {

      if (e instanceof NavigationEnd) {
        if (this.router.url == '/recorridos-ente') {
          this.menuService.titulo = this.translateService.instant('recorridos.recorridos');
          this.recorridosService.GetAll().subscribe((result) => {
            this.listaRecorridos = result.data;
          }
          );
        } else {
         
        }
      }
    });
  }

  ngOnInit(): void {
    this.recorridosService.GetAll().subscribe((result) => {
      this.listaRecorridos = result.data;
      }
    );
    this.lang = this.translateService.getDefaultLang();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = this.translateService.currentLang;
      this.menuService.titulo = this.translateService.instant('recorridos.recorridos');
    });
  }

  onClickNuevo() {
    this.router.navigate(['recorridos-crear/']);
  }

  onClickEditar() {
    if (this.seleccionados[0] > 0) {
      this.router.navigate([
        'recorridos-editar',
        {
          idrecorrido: this.seleccionados[0],
        },
      ]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate([
        'recorridos-editar',
        {
          idrecorrido: this.seleccionados[0],
        },
      ]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading) {
    this.recorridosService.delete({ codigos: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.recorridosService.GetAll().subscribe((result) => {
            this.listaRecorridos = result.data;
          }
          );
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }


}
